import React, { useEffect } from 'react';
import experiment from 'experiment';
import { cx } from '#packages/util';
import { Hidden } from '@wix/wix-ui-icons-common';
import { translate } from '#packages/i18n';
import { StageActionButton } from '#packages/sections';
import { connectWithScope } from '#packages/apilib';
import { HiddenElementsScope } from '../../hiddenElementsScope';

import {
  openMobileHiddenPanel,
  closeMobileHiddenPanel,
  isMobileHiddenPanelOpened,
} from '../../hiddenElementsApi';

import styles from './hiddenPanelOpenButton.scss';

interface HiddenPanelOpenButtonStateProps {
  isVisible: boolean;
  isHiddenComponentsPresent: boolean;
}

interface HiddenPanelOpenButtonDispatchProps {
  togglePanel: () => void;
  refreshHiddenElements: () => Promise<void>;
}

interface HiddenPanelOpenButtonOwnProps {}

interface HiddenPanelOpenButtonProps
  extends HiddenPanelOpenButtonStateProps,
    HiddenPanelOpenButtonDispatchProps,
    HiddenPanelOpenButtonOwnProps {}

const HiddenPanelOpenButtonComponent: React.FC<HiddenPanelOpenButtonProps> = ({
  isVisible,
  togglePanel,
  refreshHiddenElements,
  isHiddenComponentsPresent,
}) => {
  useEffect(() => {
    refreshHiddenElements();
  }, [refreshHiddenElements]);

  if (!isVisible) {
    return null;
  }

  return (
    <StageActionButton
      dataHook="hidden-panel-open-button"
      label={translate('mobile_hidden_items_panel_title')}
      onClick={togglePanel}
      Icon={Hidden}
      skin="lightLarge-soap"
      className={cx({
        [styles.button]: true,
        [styles.buttonWithPimple]: isHiddenComponentsPresent,
      })}
    />
  );
};

const mapStateToProps = (
  scope: HiddenElementsScope,
): HiddenPanelOpenButtonStateProps => {
  const { editorAPI, store } = scope;

  return {
    isVisible:
      editorAPI.isMobileEditor() &&
      experiment.isOpen('se_hiddenPanelFloatingFrame'),

    isHiddenComponentsPresent: store.getHiddenElementsTotalCount() > 0,
  };
};

const mapDispatchToProps = (
  scope: HiddenElementsScope,
): HiddenPanelOpenButtonDispatchProps => {
  const { privateApi } = scope;

  return {
    refreshHiddenElements: privateApi.refreshHiddenElements,
    togglePanel: () =>
      isMobileHiddenPanelOpened(scope)
        ? closeMobileHiddenPanel(scope)
        : openMobileHiddenPanel(scope, 'hidden_panel_open_button'),
  };
};

export const HiddenPanelOpenButton = connectWithScope(
  () => HiddenElementsScope,
  HiddenPanelOpenButtonComponent,
  mapStateToProps,
  mapDispatchToProps,
);
